<template>
    <div>
        <div class="store" v-for="(item, index) in list" :key="index">
            <slot name="avatar">
                <div class="avatar" @click="handleClick(item.id)">
                    <el-image :src="item.imgLogoUrl" fit="cover" ></el-image>
                </div>
            </slot>
            <slot name="info">
                <div class="info">
                    {{item.name}}
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StoreItem",
        props: ['list', 'param'],
        data() {
            return {
              type: typeof this.param === 'undefined' || typeof this.param.type === 'undefined' ? 'store' : this.param.type
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            handleClick(id) {
                if (this.type === 'store') {
                  this.$router.push({name: 'StoreInfo', query: {"id": id}});
                } else if (this.type === 'brand') {
                  this.$router.push({name: 'BrandInfo', query: {"id": id}});
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .store {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-right: 20px;
        margin-top: 6px;

        .avatar {
            width: 85px;
            height: 85px;
            border: 1px solid #D4D5D5;
            border-radius: 85px;
            overflow: hidden;

            .el-image{
                width: 100%;
                height: 100%;
                border-radius: 85px;
                //object-fit: cover;
            }
        }

        .info {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            width: 85px;
            height: 38px;
            font-size: 14px;
            line-height: 19px;
            margin-top: 8px;
            text-align: center;
        }
    }
</style>